import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {InitReservationPaymentRequest} from '../Requests/InitReservationPaymentRequest.js'

class InitReservationPaymentTransactionsUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new InitReservationPaymentTransactionsUseCase({
      config,
      repository: HTTPTransactionRepository.create({config})
    })
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'InitReservationPaymentTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({reservationId, includeTermsAndConditions = true}) {
    const initReservationPaymentRequest = InitReservationPaymentRequest.create({
      reservationId,
      includeTermsAndConditions
    })

    const [error, reservationClientSecretTransactionsValueObject] = await this.#repository.initReservationPayment(
      initReservationPaymentRequest
    )

    if (error) return Promise.reject(error)

    return reservationClientSecretTransactionsValueObject.toJSON()
  }
}

export const factory = InitReservationPaymentTransactionsUseCase.create
